import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useQuery } from 'react-query'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { IUser } from '@sales-center/common'

export const CreatedByProvider: React.FC<IProviderProps> = ({ render }) => {
  const { data, isFetching } = useQuery(
    ['filters', 'opp', 'createdBy'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'opportunities',
          'CreatedBy',
        )}`,
      )

      const users: IUser[] = await result.json()

      const options: IOption[] = users.map(({ id, fullName }) => ({
        value: id,
        label: fullName,
      }))

      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
CreatedByProvider.displayName = 'CreatedByProvider'
